import * as React from 'react';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import MembersDetailsComponent from './members.details.component';
import MembersCardComponent from './members.card.component';
import {
  Member,
  MembersDetailsMode,
  MembersState,
  MembersResponseData,
  PaymentInfo,
  ProgramMemberInfo,
  MemberType,
  MemberStatusCode,
  MakePaymentRequest
} from './members.types';
import {
  initialMemberDetail,
  TIME_BASED,
  ACTIVE,
  EXPIRED,
  memberStatus,
  NOT_AVAILABLE,
  UNASSIGNED,
  MENU_WEEKS,
  CREATE_NEW_MEMBER,
  PAYMENTS_TABLE_ROW_UNCLICKED,
  DEFAULT_PAYMENT,
  DEFAULT_PAYER,
  DEFAULT_PAY_METHOD_ID,
  PACKAGE_BASED,
  YEAR_3000_PACKAGE_BASED_END_DATE
} from './members.constants';
import { RIDIRECT_FROM_MEMBER } from '../payments/Constants';
import { BusinessState } from '../business/business.types';
import { AuthState } from '../auth/auth.types';
import { PackageState, MmsPackage } from '../mms-package/Types';
import { isAdminAccount, isImpersonating } from '../admin/Util';
import { AdminState } from '../admin/admin.types';
import './membersCard.css';
import { Schedule, ProgramsState, Program } from '../programs/Types';
import MembershipAgreement from './MembershipAgreement';
import { MEMBER, PAYMENT } from '../account/Constants';
import {
  cannotWrite,
  cannotUpdate,
  isMemberDisabled,
  isProgramDisabled,
  isPackageDisabled,
  isMarketingDisabled
} from '../util/permission.util';
import Dialog from 'material-ui/Dialog';
import { IdleState } from '../idle/Types';
import { isAuthTokenExpired } from '../commons/AuthTokenValidator';
import * as _ from 'lodash';
import ReactTable from 'react-table';
import checkboxHOC from 'react-table/lib/hoc/selectTable';
import 'react-table/react-table.css';
import { dateFromString, getLocalDate } from '../util/date-util';
import { getMembershipStatus } from './members.util';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { overlayStyle, renderOverlayLoading } from '../util/Overlay';
import CommonFeatures from '../commons/CommonFeatures';
import * as moment from 'moment';
import { monthsList, MmsColor } from '../app/app.const';
import * as validator from 'validator';
import { Currency } from '../billing/billing.types';
import { mmsStore } from 'src/app/app.config';
import { getAbsentMembers } from './members.actions';
import { EmailTemplateState } from 'src/emailTemplate/Types';
import { Filter } from 'src/util/filter';
import Chip from 'material-ui/Chip';
const CheckboxTable = checkboxHOC(ReactTable);
const monthMapping = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December'
};

type FilterOption = 'Member ID' | 'Name' | 'Expiring' | 'Absent' |
  'Status' | 'Program' | 'Tag' | 'Birth Date' | 'Point' | 'Phone';

type TableDataType = {
  readonly id: number
  readonly memberId: string
  readonly firstName: string
  readonly lastName: string
  readonly endDate: string
  readonly dateOfBirth: string
  readonly status: MemberStatusCode
  readonly programs: string[]
  readonly endDateNumber: number
};

type Props = {
  readonly authState: AuthState
  readonly adminState: AdminState
  readonly programsState: ProgramsState
  readonly membersState: MembersState
  readonly packageState: PackageState
  readonly emailTemplateState: EmailTemplateState
  readonly getMembers?: () => Promise<MembersResponseData>
  readonly getMember?: (memberId: number) => Promise<MembersResponseData>
  readonly getAbsentMembers?: (weeks: number) => Promise<MembersResponseData>
  readonly createMember?: (
    file: File | null,
    firstName: string,
    lastName: string,
    initial: string,
    gender: string,
    birthDate: number,
    email: string,
    address: string,
    city: string,
    province: string,
    country: string,
    postalCode: string,
    mobile1: string,
    mobile2: string | undefined,
    startDate: number,
    endDate: number,
    emergencyContactName1: string | undefined,
    emergencyContactNumber1: string | undefined,
    emergencyContactName2: string | undefined,
    emergencyContactNumber2: string | undefined,
    emergencyContactName3: string | undefined,
    emergencyContactNumber3: string | undefined,
    checkinNotification: string,
    contractDuration: string,
    maxAttendancePerWeek: number,
    point: number,
    note: string,
    emailConsent: Boolean,
    smsConsent: Boolean,
    remainingClasses: number,
    memberType: MemberType,
    tags: string[]
  ) => Promise<MembersResponseData>
  readonly updateMember?: (
    id: number,
    file: File | null,
    firstName: string,
    lastName: string,
    initial: string,
    gender: string,
    birthDate: number,
    email: string,
    address: string,
    city: string,
    province: string,
    country: string,
    postalCode: string,
    mobile1: string,
    mobile2: string | undefined,
    startDate: number,
    endDate: number,
    emergencyContactName1: string | undefined,
    emergencyContactNumber1: string | undefined,
    emergencyContactName2: string | undefined,
    emergencyContactNumber2: string | undefined,
    emergencyContactName3: string | undefined,
    emergencyContactNumber3: string | undefined,
    checkinNotification: string,
    contractDuration: string,
    maxAttendancePerWeek: number,
    point: number,
    note: string,
    emailConsent: Boolean,
    smsConsent: Boolean,
    cancelled: boolean,
    remainingClasses: number,
    memberType: MemberType,
    tags: string[],
    cancelPayment: boolean,
    sendNotificationToMember: boolean

  ) => Promise<MembersResponseData>
  readonly toAdminDashboard?: () => void
  readonly businessState: BusinessState
  readonly toDashboard?: () => void
  readonly toPaymentList?: () => void
  readonly idleState: IdleState
  readonly getPrograms?: () => Promise<Response>
  readonly bulkCancel?: (
    memberIds: number[],
    cancelMembership: boolean,
    cancelPayment: boolean
  ) => Promise<MembersResponseData>
  readonly bulkAddDaysToEndDates?: (memberIds: number[], days: number) => Promise<MembersResponseData>
  readonly bulkSendEmail?: (
    memberIds: number[],
    emailTemplateId: number
  ) => Promise<MembersResponseData>
  readonly bulkSendSms?: (memberIds: number[], smsBody: string, sendMobile2: boolean) => Promise<MembersResponseData>
  readonly exportCsv?: (memberIds: number[]) => Promise<MembersResponseData>
  readonly createPayment: (
    id: number,
    paymentType: string,
    downPayment: number,
    total: number,
    amountPerTransaction: number,
    currency: Currency | '',
    term: string,
    numberOfTransactions: number,
    startDate: number,
    payerId: number,
    memberId: number,
    paymentMethodId: number,
    continuous: boolean,
    schedules: {
      scheduledPaymentId: number,
      chargeDate: number,
      amount: number,
      status: string
    }[],
    description?: string
  ) => Promise<Response>
  readonly cancelMemberPayment: (paymentId: number) => Promise<Response>
  readonly getPackages: () => Promise<Response>
  readonly getEmailTemplates: () => Promise<Response>
};

type States = {
  readonly loading: boolean
  readonly members: Member[]
  readonly showMemberDetailsModal: boolean
  readonly memberDetailsMode: MembersDetailsMode
  readonly detailDisplayMember: Member
  readonly hasMemberDetailError: boolean
  readonly currentPaymentInfo: PaymentInfo
  readonly currentProgramMembers: ProgramMemberInfo[]
  readonly memberImageFile?: File
  readonly membersToPrint: Member[]
  readonly warningDialogOpen: boolean
  readonly warningDialogMessage: string
  readonly shouldPrintMembersCard: boolean
  readonly shouldPrintEnrollmentForm: boolean
  readonly confirmationModalOpen: boolean
  readonly badProfilePicModalOpen: boolean
  readonly loadedMembersList: boolean
  readonly selectedMemberType: MemberType
  readonly unsavedRemainingClasses: number
  readonly selectAll: boolean
  readonly selection: number[]
  readonly tableData: TableDataType[],
  readonly openActionsModal: boolean
  readonly filterOption: FilterOption
  readonly expiringInWeekFilter: number
  readonly absentInWeekFilter: number
  readonly statusFilter: string
  readonly tags: string[]
  readonly filterByStatusValue: MemberStatusCode[]
  readonly filterById: string
  readonly filterByName: string
  readonly filterByProgram: string
  readonly filterByBirthDate: number
  readonly filterByPoint: number
  readonly filterByPhone: string
  readonly filterByPointError: string
  readonly addDaysToEndDateSelected: boolean
  readonly cancelSelectedMembershipsSelected: boolean
  readonly cancelSelectedMembershipsAndPaymentsSelected: boolean
  readonly printSelectedMembershipCardsSelected: boolean
  readonly daysToAdd: number
  readonly loadingActions: boolean
  readonly filterByTag: string
  readonly isApiCalledAlready: boolean
  readonly selectedSendCancellationNotification: boolean
  readonly sendMassEmailSelected: boolean
  readonly emailTemplateId: number
  readonly smsContent: string
  readonly sendMassSMSSelected: boolean
  readonly sendMassSMSToMobile2: boolean
  readonly fileSizeError: string
  readonly fileFormatError: string
  readonly cancellingPayment: boolean
  readonly cancellingPaymentError: string
  readonly creatingPayment: boolean
  readonly createPaymentError: string
  readonly makePaymentRequest?: MakePaymentRequest
  readonly unsavedPaymentModal: boolean
  readonly openPaymentCancellationConfirmModal: boolean
  readonly selectedCancelPayment: boolean
  readonly openRedirectPageModal: boolean
  readonly isCreateRedirectAction: boolean
  readonly exportCsv: boolean
  readonly openFilterModal: boolean
  readonly filters: Filter[]
  readonly filterField: string
  readonly filterOperation: string
  readonly filterValue: string
};

class MembersComponent extends React.Component<Props, States> {

  checkboxTable = null;

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false,
      members: [],
      showMemberDetailsModal: false,
      memberDetailsMode: 'CREATE',
      detailDisplayMember: _.cloneDeep(initialMemberDetail),
      hasMemberDetailError: false,
      currentPaymentInfo: _.cloneDeep(initialMemberDetail.payments[0]),
      currentProgramMembers: [],
      memberImageFile: undefined,
      membersToPrint: [],
      warningDialogOpen: false,
      warningDialogMessage: '',
      shouldPrintMembersCard: false,
      shouldPrintEnrollmentForm: false,
      confirmationModalOpen: false,
      badProfilePicModalOpen: false,
      loadedMembersList: false,
      selectedMemberType: props.membersState.member && props.membersState.member.memberType ?
        props.membersState.member.memberType :
        TIME_BASED,
      unsavedRemainingClasses: 0,
      selectAll: false,
      selection: [],
      tableData: [],
      openActionsModal: false,
      filterOption: 'Name',
      expiringInWeekFilter: 0,
      absentInWeekFilter: 0,
      statusFilter: NOT_AVAILABLE,
      tags: [],
      filterByStatusValue: [ACTIVE, EXPIRED],
      filterById: '',
      filterByName: '',
      filterByProgram: NOT_AVAILABLE,
      filterByBirthDate: undefined,
      filterByPoint: 0,
      filterByPointError: '',
      addDaysToEndDateSelected: false,
      cancelSelectedMembershipsSelected: false,
      cancelSelectedMembershipsAndPaymentsSelected: false,
      printSelectedMembershipCardsSelected: false,
      daysToAdd: 0,
      loadingActions: false,
      filterByTag: NOT_AVAILABLE,
      isApiCalledAlready: false,
      selectedSendCancellationNotification: false,
      sendMassEmailSelected: false,
      emailTemplateId: undefined,
      smsContent: '',
      sendMassSMSSelected: false,
      sendMassSMSToMobile2: false,
      fileSizeError: '',
      fileFormatError: '',
      filterByPhone: '',
      cancellingPayment: false,
      cancellingPaymentError: '',
      creatingPayment: false,
      createPaymentError: '',
      unsavedPaymentModal: false,
      openPaymentCancellationConfirmModal: false,
      selectedCancelPayment: false,
      openRedirectPageModal: false,
      isCreateRedirectAction: false,
      exportCsv: false,
      openFilterModal: false,
      filters: [{field: 'Status', operation: 'is', value: 'Active'}],
      filterField: '',
      filterOperation: '',
      filterValue: ''
    };

    this.memberClickHandler = this.memberClickHandler.bind(this);
    this.addMemberToPrintHandler = this.addMemberToPrintHandler.bind(this);
    this.removeMemberFromPrintHandler = this.removeMemberFromPrintHandler.bind(this);
    this.clearMembersFromPrint = this.clearMembersFromPrint.bind(this);
    this.toggleMembersDetailsModal = this.toggleMembersDetailsModal.bind(this);
    this.onMemberImageFileChangeHandler = this.onMemberImageFileChangeHandler.bind(this);
    this.onClickMemberSubmit = this.onClickMemberSubmit.bind(this);
    this.isMemberInfoComplete = this.isMemberInfoComplete.bind(this);
    this.isProgramDetailUpdated = this.isProgramDetailUpdated.bind(this);
    this.memberChangeHandler = this.memberChangeHandler.bind(this);
    this.printMemberEnrollmentForm = this.printMemberEnrollmentForm.bind(this);
    this.printMembersCards = this.printMembersCards.bind(this);
  }

  componentDidMount() {
    const { authState, toAdminDashboard, adminState, toDashboard } = this.props;

    if (isAdminAccount(authState) && !isImpersonating(adminState)) {
      return toAdminDashboard();
    }

    if (!isMemberDisabled(authState, adminState)) {
      this.setState(
        { isApiCalledAlready: true },
        () => {
          this.props.getPrograms();
          this.loadMembersList();
        }
      );
    } else {
      return toDashboard();
    }

    if (!isPackageDisabled(authState, adminState)) {
      this.props.getPackages();
    }

    if (!isMarketingDisabled(authState, adminState)) {
      this.props.getEmailTemplates();
    }

    window.onpopstate = (e) => {
      if (this.state.showMemberDetailsModal) {
        history.go(1);
      }
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    if (
      this.props !== nextProps &&
      this.state.members.length === 0 &&
      !nextProps.idleState.expired &&
      nextProps.authState.statusCode === 200 &&
      !this.state.loadedMembersList &&
      !this.state.isApiCalledAlready
    ) {
      this.setState({ isApiCalledAlready: true }, this.loadMembersList);
    } else if (nextProps.membersState.statusCode !== 400) {
      this.setState(
        {
          selection: [],
          members: nextProps.membersState.members,
          tableData: nextProps.membersState.members.map((m: Member) => this.createTableData(m))
        },
        this.applyFilters
      );
    }
  }

  componentWillUnmount() {
    this.setState({
      loading: false,
      loadedMembersList: false,
      openActionsModal: false,
      loadingActions: false,
      cancellingPayment: false,
      cancellingPaymentError: '',
      creatingPayment: false,
      createPaymentError: '',
      unsavedPaymentModal: false,
      openPaymentCancellationConfirmModal: false,
      selectedCancelPayment: false,
      emailTemplateId: undefined,
    });
  }

  render() {

    const { businessState } = this.props;

    const {
      membersToPrint,
      detailDisplayMember,
      shouldPrintMembersCard,
      shouldPrintEnrollmentForm,
      openActionsModal,
      printSelectedMembershipCardsSelected,
      loadingActions,
      showMemberDetailsModal
    } = this.state;

    // It looks like it takes some time to pass members stored in local state to print preview, some hacky thing below
    if (membersToPrint.length > 0 && !openActionsModal && printSelectedMembershipCardsSelected && loadingActions) {
      setTimeout(this.printMembersCards, 2000);
    }

    return (
      <div>
        <div id="react-no-print">
          <CommonFeatures
            authState={this.props.authState}
            businessState={this.props.businessState}
          >
            {
              (showMemberDetailsModal)
                ? this.renderMembersDetailsPage()
                : this.renderMembersMainPage()
            }
            {this.renderActionsModal()}
            {this.renderRedirectPageModal()}
            {this.renderFilterModal()}
          </CommonFeatures>
        </div>
        <div id="print-mount">
          <div style={{ display: shouldPrintMembersCard ? 'block' : 'none' }}>
            <MembersCardComponent
              members={membersToPrint}
              business={businessState.business}
            />
          </div>
          <div style={{ display: shouldPrintEnrollmentForm ? 'block' : 'none' }}>
            <MembershipAgreement
              member={detailDisplayMember}
            />
          </div>
        </div>
      </div>
    );
  }

  handleFilterByBirthDateMonthChange = (event: React.SyntheticEvent<{}>, index: number, value: number): void => {
    this.setState({ filterByBirthDate: value }, this.applyFilters);
  }

  handleMemberIdFilterChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    this.setState({ filterById: newValue.toLowerCase() }, this.applyFilters);
  }

  handleNameFilterChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    this.setState({ filterByName: newValue.toLowerCase() }, this.applyFilters);
  }

  handleExpiringWeekChange = (event: React.SyntheticEvent<{}>, index: number, value: number): void => {
    this.setState({ expiringInWeekFilter: value }, this.applyFilters);
  }

  handleAbsentWeekChange = (event: React.SyntheticEvent<{}>, index: number, value: number): void => {
    this.setState({ absentInWeekFilter: value, loadedMembersList: false }, () => {
      this.props.getAbsentMembers(this.state.absentInWeekFilter).then(response => {
        switch (this.props.membersState.statusCode) {
          case 404:
            return;
          case 403:
            return this.props.toDashboard();
          case 200:
            return this.setState(
              {
                loadedMembersList: true
              }
            );
          default:
            return;
        }
      });
    });
  }

  handleFilterByTagChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void => {
    this.setState({ filterByTag: value }, this.applyFilters);
  }

  handleFilterByPhoneChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    this.setState({ filterByPhone: newValue }, this.applyFilters);
  }

  handleFilterByPointChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    this.setState(
      {
        filterByPoint: validator.isNumeric(newValue) ? parseInt(newValue, 10) : undefined,
        filterByPointError: validator.isNumeric(newValue) ? '' : 'Enter valid number'
      },
      this.applyFilters
    );
  }

  private renderMembersMainPage = (): JSX.Element => {
    const {
      toggleSelection,
      toggleAll,
      isSelected
    } = this;

    const {
      authState,
      adminState
    } = this.props;

    const {
      selectAll,
      loadingActions
    } = this.state;

    const checkboxProps = {
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
      selectType: 'checkbox',
    };

    return (
      <div>
        <div className="page-header-row row mt-2">
          <div className="col-auto">
            <h3>Members</h3>
          </div>
        </div>
        <div className="row mt3 mb3 justify-content-end">
          <div className="col">
            <div className="float-left ml3">
              <RaisedButton
                label="ADD FILTER"
                primary={true}
                onClick={this.onAddFilterClick}
                className="mb3"
              />
              <div>
                {this.renderFilters()}
              </div>
            </div>
          </div>
          <div className="col-auto">
            {
              loadingActions ?
                <RefreshIndicator
                  size={40}
                  left={10}
                  top={0}
                  status="loading"
                  style={{
                    display: 'inline-block',
                    position: 'relative',
                    float: 'right',
                    marginRight: '3rem'
                  }}
                /> :
                <RaisedButton
                  label="Actions"
                  primary={true}
                  onClick={() => this.setState({
                    openActionsModal: true,
                    membersToPrint: this.state.members.filter((m: Member) => this.state.selection.includes(m.id))
                  })}
                  disabled={cannotWrite(MEMBER, authState, adminState) || this.state.selection.length === 0}
                />
            }
          </div>
          <div className="col-auto">
            <RaisedButton
              label="+ New Member"
              fullWidth={true}
              primary={true}
              onClick={() => {
                mmsStore.dispatch({ type: PAYMENTS_TABLE_ROW_UNCLICKED });
                mmsStore.dispatch({ type: CREATE_NEW_MEMBER });
                this.setState(
                  { memberDetailsMode: 'CREATE' },
                  this.toggleMembersDetailsModal
                );
              }}
              disabled={cannotWrite(MEMBER, authState, adminState)}
              style={{ paddingRight: 0 }}
            />
          </div>
        </div>
        <div className="row mb-4 mt-4 animated fadeIn">
          <div
            className="col-12"
            style={overlayStyle(this.state.loadedMembersList)}
          >
            {renderOverlayLoading(this.state.loadedMembersList, '25%')}
            <CheckboxTable
              ref={(r) => this.checkboxTable = r}
              data={this.generateTableData()}
              columns={[
                {
                  accessor: 'memberId',
                  Header: 'Member ID',
                  style: { textAlign: 'center' },
                  Footer: (
                    <span className="blue">
                      <strong>Total Members :</strong>{' '}
                      {this.applyFilters().length}
                    </span>
                  )
                },
                {
                  accessor: 'firstName',
                  Header: 'First Name',
                  style: { textAlign: 'center' }
                },
                {
                  accessor: 'lastName',
                  Header: 'Last Name',
                  style: { textAlign: 'center' }
                },
                {
                  accessor: 'endDate',
                  Header: 'End Date',
                  style: { textAlign: 'center' },
                  sortMethod: (a, b, desc) => {
                    if (dateFromString(a) > dateFromString(b)) {
                      return 1;
                    } else if (dateFromString(a) < dateFromString(b)) {
                      return -1;
                    } else {
                      return 0;
                    }
                  }
                },
                {
                  accessor: 'dateOfBirth',
                  Header: 'Date Of Birth',
                  style: { textAlign: 'center' },
                  sortMethod: (a, b, desc) => {
                    if (dateFromString(a) > dateFromString(b)) {
                      return 1;
                    } else if (dateFromString(a) < dateFromString(b)) {
                      return -1;
                    } else {
                      return 0;
                    }
                  }
                },
                {
                  accessor: 'status',
                  Header: 'Status',
                  style: { textAlign: 'center' }
                }
              ]}
              defaultPageSize={100}
              className="-striped -highlight"
              keyField={'id'}
              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => rowInfo ? this.memberClickHandler(rowInfo.original.id) : null
                };
              }}

              {...checkboxProps}
            />
          </div>
        </div>
      </div>
    );
  }

  private onAddFilterClick = (): void =>
    this.setState({
      openFilterModal: true
    })

  private renderFilterModal = () => {
    if (this.state.openFilterModal) {
      return (
        <Dialog
          title="Add Filter"
          actions={[
            this.renderAddButton(),
            this.renderCloseButton()
          ]}
          modal={true}
          open={this.state.openFilterModal}
          autoScrollBodyContent={true}
        >
          <div className="mr-1">
            <div className="mr-1">
              <SelectField
                floatingLabelText="Field"
                value={this.state.filterField}
                onChange={this.handleFilterFieldChange}
              >
                <MenuItem value={'Status'} primaryText={'Status'} />
                <MenuItem value={'Name'} primaryText={'Name'} />
                <MenuItem value={'Expiring'} primaryText={'Expiring'} />
                <MenuItem value={'Absent'} primaryText={'Absent'} />
                <MenuItem value={'Program'} primaryText={'Program'} />
                <MenuItem value={'Tag'} primaryText={'Tag'} />
                <MenuItem value={'Date of Birth'} primaryText={'Date of Birth'} />
                <MenuItem value={'Point'} primaryText={'Point'} />
                <MenuItem value={'Phone'} primaryText={'Phone'} />
              </SelectField>
            </div>
            <div className="mr-1">
              {this.renderOperationOptions()}
            </div>
            {this.renderFilterValueOptions()}
          </div>

        </Dialog>
      );
    } else {
      return null;
    }
  }

  private renderFilters = (): JSX.Element => {
    const { filters } = this.state;

    return (
      <div>
        {filters.map((filter, index) => {
          return (
            <Chip
              key={filter.field + ' ' + filter.operation + ' ' + filter.value}
              onRequestDelete={() => {
                var tempFilters = filters.filter(f => f.field + ' ' + f.operation + ' ' + f.value
                  !== filter.field + ' ' + filter.operation + ' ' + filter.value);
                this.setState({ filters: tempFilters });
              }
              }
              style={{ margin: 4, float: 'left' }}
            >
              {filter.field + ' ' + filter.operation + ' ' + filter.value}
            </Chip>
          );
        })}
      </div>
    );
  }

  private renderAddButton = () => {
    return (
      <RaisedButton
        label="ADD"
        secondary={true}
        keyboardFocused={true}
        className="mr-2"
        onClick={() => {
          var tempFilters = this.state.filters;
          tempFilters.push({
            field: this.state.filterField,
            operation: this.state.filterOperation,
            value: this.state.filterValue
          });
          this.setState({
            openFilterModal: false,
            filters: tempFilters,
            filterField: '',
            filterOperation: '',
            filterValue: ''
          }, this.generateTableData);
        }
        }
      />
    );
  }

  private renderCloseButton = () => {
    return (
      <RaisedButton
        label="CLOSE"
        secondary={true}
        keyboardFocused={true}
        className="mr-2"
        onClick={() => this.setState({
          openFilterModal: false,
          filterField: '',
          filterOperation: '',
          filterValue: ''
        })}
      />
    );
  }

  private generateTableData = () => {
    return this.applyFilters().map((m: Member) => {
      return this.createTableData(m);
    });
  }

  private renderOperationOptions = () => {

    switch (this.state.filterField) {
      case 'Status':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Name':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'contains'} primaryText={'Contains'} />
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Expiring':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'in'} primaryText={'In'} />
          </SelectField>
        );
      case 'Absent':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'for'} primaryText={'For'} />
          </SelectField>
        );
      case 'Program':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Tag':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      case 'Date of Birth':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'in'} primaryText={'In'} />
          </SelectField>
        );
      case 'Point':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'lt'} primaryText={'Less Than'} />
            <MenuItem value={'lte'} primaryText={'Less Than Or Equal To'} />
            <MenuItem value={'eq'} primaryText={'Equal To'} />
            <MenuItem value={'gte'} primaryText={'Greater Than Or Equal To'} />
            <MenuItem value={'gt'} primaryText={'Greater Than'} />
          </SelectField>
        );
      case 'Phone':
        return (
          <SelectField
            floatingLabelText="Operation"
            value={this.state.filterOperation}
            onChange={this.handleFilterOperationChange}
          >
            <MenuItem value={'contains'} primaryText={'Contains'} />
            <MenuItem value={'is'} primaryText={'Is'} />
          </SelectField>
        );
      default:
        return (
          null
        );
    }
  }

  private renderFilterValueOptions = () => {

    switch (this.state.filterField) {
      case 'Status':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            <MenuItem value={'Active'} primaryText={'Active'} />
            <MenuItem value={'Expired'} primaryText={'Expired'} />
            <MenuItem value={'Cancelled'} primaryText={'Cancelled'} />
          </SelectField>
        );
      case 'Name':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      case 'Expiring':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            <MenuItem value={'1 week'} primaryText={'1 week'} />
            <MenuItem value={'2 weeks'} primaryText={'2 weeks'} />
            <MenuItem value={'3 weeks'} primaryText={'3 weeks'} />
            <MenuItem value={'4 weeks'} primaryText={'4 weeks'} />
          </SelectField>
        );
      case 'Absent':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            <MenuItem value={'1 week'} primaryText={'1 week'} />
            <MenuItem value={'2 weeks'} primaryText={'2 weeks'} />
            <MenuItem value={'3 weeks'} primaryText={'3 weeks'} />
            <MenuItem value={'4 weeks'} primaryText={'4 weeks'} />
          </SelectField>
        );
      case 'Program':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            {this.props.programsState.programs.map((p: Program) => {
              return <MenuItem key={p.id} value={p.name} primaryText={p.name} />;
            })}
          </SelectField>
        );
      case 'Tag':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            {this.props.businessState.business.tags.map((t: string, index: number) => {
              return <MenuItem key={index} value={t} primaryText={t} />;
            })}
          </SelectField>
        );
      case 'Date of Birth':
        return (
          <SelectField
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueListChange}
          >
            <MenuItem value={'January'} primaryText={'January'} />
            <MenuItem value={'February'} primaryText={'February'} />
            <MenuItem value={'March'} primaryText={'March'} />
            <MenuItem value={'April'} primaryText={'April'} />
            <MenuItem value={'May'} primaryText={'May'} />
            <MenuItem value={'June'} primaryText={'June'} />
            <MenuItem value={'July'} primaryText={'July'} />
            <MenuItem value={'August'} primaryText={'August'} />
            <MenuItem value={'September'} primaryText={'September'} />
            <MenuItem value={'October'} primaryText={'October'} />
            <MenuItem value={'November'} primaryText={'November'} />
            <MenuItem value={'December'} primaryText={'December'} />
          </SelectField>
        );
      case 'Point':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      case 'Phone':
        return (
          <TextField
            fullWidth={true}
            floatingLabelText="Value"
            value={this.state.filterValue}
            onChange={this.handleFilterValueChange}
          />
        );
      default:
        return (
          null
        );
    }
  }

  private handleFilterFieldChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({
      filterField: value,
      filterOperation: '',
      filterValue: ''
    })

  private handleFilterOperationChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({
      filterOperation: value,
      filterValue: ''
    })

  private handleFilterValueListChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({ filterValue: value })

  private handleFilterValueChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void => {
    this.setState({
      filterValue: newValue
    });
  }

  private renderMembersDetailsPage = (): JSX.Element => {
    const {
      authState,
      adminState,
      businessState,
      membersState
    } = this.props;

    const {
      detailDisplayMember,
      memberDetailsMode,
      loading,
      selectedMemberType,
      selectedSendCancellationNotification,
      selectedCancelPayment,
      makePaymentRequest,
      fileFormatError,
      fileSizeError
    } = this.state;

    return (
      <div
        style={{
          display: 'flex',
          flexFlow: 'column',
          minHeight: 'calc(100vh - 80px)'
        }}
      >
        <MembersDetailsComponent
          member={detailDisplayMember}
          memberChangeHandler={this.memberChangeHandler}
          selectedMemberType={selectedMemberType}
          selectedMemberTypeChangeHandler={this.selectedMemberTypeChangeHandler}
          mode={memberDetailsMode}
          onMemberImageFileChangeHandler={this.onMemberImageFileChangeHandler}
          authState={authState}
          adminState={adminState}
          membersState={membersState}
          businessState={businessState}
          selectedSendCancellationNotification={selectedSendCancellationNotification}
          handleSendCancellationNotificationClick={this.handleSendCancellationNotificationClick}
          fileSizeError={fileSizeError}
          fileFormatError={fileFormatError}
          makePaymentRequestHandler={this.makePaymentRequestHandler}
          makePaymentRequest={makePaymentRequest}
          selectedCancelPayment={selectedCancelPayment}
          handleCancelPaymentClick={this.handleCancelPaymentClick}
          handleRedirectToPaymentListPage={this.handleRedirectToPaymentListPage}

        />
        <div className="row" style={{ flexGrow: 1 }}>
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 pb-5">
            {this.state.createPaymentError ?
              <b className="red">{this.state.createPaymentError}</b> :
              null
            }
          </div>
          <div
            className="col-lg-8 col-md-8 col-sm-12 col-xs-12 pb-5"
            style={{ backgroundColor: MmsColor.LightGrey }}
          >
            {
              loading ?
                <div className="mb-5">
                  <RefreshIndicator
                    size={40}
                    left={10}
                    top={0}
                    status="loading"
                    style={{
                      display: 'inline-block',
                      position: 'relative',
                      float: 'right',
                      marginRight: '3rem'
                    }}
                  />
                </div> :
                this.renderMemberDetailsButtons()
            }
          </div>
        </div>
        {this.renderConfirmationModal()}
        {this.renderBadProfilePicModal()}
        {this.renderUnsavedPaymentModal()}
        {this.paymentCancellationConfirmModal()}
      </div>
    );
  }

  private makePaymentRequestHandler = (r: MakePaymentRequest) => {
    this.setState({ makePaymentRequest: r });
  }

  private renderMemberDetailsButtons = (): JSX.Element => {
    const { authState, adminState, membersState } = this.props;

    return (
      <div className="mb-5">
        <RaisedButton
          label="Close"
          secondary={true}
          className="float-right mr-3"
          onClick={this.props.membersState.member.payments.filter(p => p && p.id !== DEFAULT_PAYMENT.id).length > 0
            && this.state.memberDetailsMode === 'CREATE' ?
            () => this.setState({ unsavedPaymentModal: true }) :
            this.toggleMembersDetailsModal
          }
        />
        <RaisedButton
          label="Submit"
          primary={true}
          className="float-right mr-2"
          disabled={
            this.state.hasMemberDetailError ||
            !this.isMemberInfoComplete() ||
            (
              cannotWrite(MEMBER, authState, adminState) &&
              cannotUpdate(MEMBER, authState, adminState)
            )
          }
          onClick={this.onClickMemberSubmit}
        />
      </div>
    );
  }

  private paymentCancellationConfirmModal = () => {
    return (
      <Dialog
        title="Actions"
        actions={[
          this.renderNoButtonForCancellation(),
          this.renderConfirmButton()
        ]}
        modal={true}
        open={this.state.openPaymentCancellationConfirmModal}
        onRequestClose={() => this.setState({ openPaymentCancellationConfirmModal: false })}
        autoScrollBodyContent={true}
      >
        Do you really want to cancel the payment?
      </Dialog>
    );
  }

  private renderRedirectPageModal = (): JSX.Element => {
    return (
      <Dialog
        title="Redirect Page"
        actions={this.renderRedirectPageModalActionButtons()}
        modal={true}
        open={this.state.openRedirectPageModal}
        onRequestClose={() => this.setState({ openRedirectPageModal: false })}
        autoScrollBodyContent={true}
      >
        {
          (this.state.isCreateRedirectAction) ?
            'Would you like to create payments for the member?' :
            'This action will redirect to another page. Save before moving to the page to keep the changes.'
        }
      </Dialog>
    );
  }

  private renderRedirectPageModalActionButtons = (): Array<JSX.Element> => {
    const { toPaymentList } = this.props;
    const { isCreateRedirectAction } = this.state;

    return [
      (
        <RaisedButton
          key={1}
          className="mr-2"
          label={(isCreateRedirectAction) ? 'No' : 'Cancel'}
          secondary={true}
          onClick={() => this.setState({ openRedirectPageModal: false })}
        />
      ),
      (
        <RaisedButton
          key={2}
          className="mr-2"
          label={(isCreateRedirectAction) ? 'Yes' : 'Don\'t Save'}
          primary={true}
          onClick={() =>
            this.setState({
              openRedirectPageModal: false
            }, toPaymentList)
          }
        />
      ),
      (
        <RaisedButton
          key={3}
          label="Save"
          primary={true}
          className={(isCreateRedirectAction) ? 'd-none' : 'mr-2'}
          disabled={
            !this.isMemberInfoComplete() ||
            this.state.hasMemberDetailError ||
            this.state.detailDisplayMember.id === 0 ||
            isCreateRedirectAction
          }
          onClick={this.onClickMemberSubmit}
        />
      )
    ];
  }

  private handleCancelPaymentClick = (): void =>
    this.setState((prevState) => ({ selectedCancelPayment: !prevState.selectedCancelPayment }))

  private renderNoButtonForCancellation = () => {
    return (
      <FlatButton
        label="No"
        primary={true}
        onClick={() => this.setState({ openPaymentCancellationConfirmModal: false })}
      />
    );
  }

  private renderConfirmButton = () => {
    if (this.state.cancellingPayment) {
      return (
        <RefreshIndicator
          size={40}
          left={10}
          top={0}
          status="loading"
          style={{
            display: 'inline-block',
            position: 'relative',
            float: 'right',
            marginRight: '3rem'
          }}
        />
      );
    } else {
      return (
        <FlatButton
          label="Yes"
          primary={true}
          onClick={() => {
            this.setState(
              { cancellingPayment: true },
              () => {
                this.props.cancelMemberPayment(this.props.membersState.selectedPayment.id)
                  .then(res => {
                    switch (this.props.membersState.statusCode) {
                      case 200:
                        return this.setState(
                          {
                            cancellingPaymentError: '',
                            cancellingPayment: false,
                            openPaymentCancellationConfirmModal: false
                          },
                          () => {
                            mmsStore.dispatch({ type: PAYMENTS_TABLE_ROW_UNCLICKED });
                          }
                        );
                      case 400:
                        return this.setState({
                          cancellingPaymentError: 'Cancelling the payment failed.',
                          cancellingPayment: false,
                          openPaymentCancellationConfirmModal: false
                        });
                      case 403:
                        return this.setState({
                          cancellingPaymentError: 'Cancelling the payment failed.',
                          cancellingPayment: false,
                          openPaymentCancellationConfirmModal: false
                        });
                      default:
                        return this.setState({
                          cancellingPaymentError: 'Cancelling the payment failed.',
                          cancellingPayment: false,
                          openPaymentCancellationConfirmModal: false
                        });
                    }
                  });
              }
            );
          }}
        />
      );
    }
  }

  private handleSendCancellationNotificationClick = (): void =>
    this.setState((prevState) => ({
      selectedSendCancellationNotification: !prevState.selectedSendCancellationNotification
    }))

  private onFilterByStatusValueChange = (
    event: React.TouchEvent<HTMLSelectElement>,
    index: number,
    value: MemberStatusCode[]
  ): void => this.setState({ filterByStatusValue: value }, this.applyFilters)

  private renderProgramItems = (): JSX.Element[] => {
    return (
      this.props.programsState.programs.map((p: Program, key: number) => {
        return <MenuItem key={key} value={p.name} primaryText={p.name} />;
      })
    );
  }

  private renderActionsModal = (): JSX.Element => {
    return (
      <Dialog
        title="Actions"
        actions={[
          this.renderCancelButton(this.closeActionsModal),
          this.renderSubmitButton(this.onClickActionSubmit, this.isSubmitButtonDisabled())
        ]}
        modal={true}
        open={this.state.openActionsModal}
        onRequestClose={() => this.setState({ openActionsModal: false })}
        repositionOnUpdate={false}
        style={{ paddingTop: '0%' }}
        autoScrollBodyContent={true}
      >
        <div>
          <div className="row align-items-center">
            <div className="col-5">
              <Checkbox
                label="Add Days To End Date"
                checked={this.state.addDaysToEndDateSelected}
                onCheck={this.checkAddDays}
              />
            </div>
            <div className="col-7 mb4">
              <TextField
                hintText="Days To Add"
                floatingLabelText="Days To Add"
                onChange={this.onDaysToAddChange}
                disabled={!this.state.addDaysToEndDateSelected}
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-7 mb4">
              <Checkbox
                label="Cancel selected memberships"
                checked={this.state.cancelSelectedMembershipsSelected}
                onCheck={this.checkCancelMemberships}
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-7 mb4">
              <Checkbox
                label="Cancel selected memberships and all payments"
                checked={this.state.cancelSelectedMembershipsAndPaymentsSelected}
                onCheck={this.checkCancelMembershipsAndPayments}
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-7 mb4">
              <Checkbox
                label="Print selected membership cards"
                checked={this.state.printSelectedMembershipCardsSelected}
                onCheck={this.checkPrint}
              />
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-12 mb4">
              <Checkbox
                label="Send emails to members"
                checked={this.state.sendMassEmailSelected}
                onCheck={this.checkMassEmail}
                disabled={
                  this.props.businessState.business && !this.props.businessState.business.emailVerified
                }
              />
              {this.renderEmailTemplateSelect()}
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-5">
              <Checkbox
                label="Export members"
                checked={this.state.exportCsv}
                onCheck={this.checkExportCsv}
              />
            </div>
          </div>
        </div>
      </Dialog>
    );
  }

  private isSubmitButtonDisabled = (): boolean => {
    const { sendMassEmailSelected, emailTemplateId } = this.state;

    if (sendMassEmailSelected) {
      return emailTemplateId === undefined;
    } else {
      return false;
    }
  }

  private renderEmailTemplateSelect = (): JSX.Element => {
    if (
      this.state.sendMassEmailSelected &&
      this.props.businessState.business &&
      this.props.businessState.business.emailVerified &&
      this.props.emailTemplateState.emailTemplates
    ) {
      return (
        <div>
          <SelectField
            floatingLabelText="Select Email Template"
            value={this.state.emailTemplateId}
            onChange={this.handleEmailTemplateSelectChange}
          >
            {
              this.props.emailTemplateState.emailTemplates.map(
                (template, index) => {
                  return <MenuItem key={index} value={template.id} primaryText={template.name} />;
                })
            }
          </SelectField>
        </div>
      );
    } else if (
      this.props.businessState.business &&
      !this.props.businessState.business.emailVerified
    ) {
      return (<div className="red">Please verify your email first before sending emails to members.</div>);
    } else {
      return (null);
    }
  }

  private handleEmailTemplateSelectChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({ emailTemplateId: isNaN(parseInt(value, 10)) ? 0 : parseInt(value, 10) })

  private onDaysToAddChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({ daysToAdd: isNaN(parseInt(newValue, 10)) ? 0 : parseInt(newValue, 10) })

  private onMassSMSContentChange = (event: React.FormEvent<HTMLInputElement>, newValue: string): void =>
    this.setState({ smsContent: newValue })

  private checkAddDays = (): void =>
    this.setState({
      addDaysToEndDateSelected: true,
      cancelSelectedMembershipsSelected: false,
      cancelSelectedMembershipsAndPaymentsSelected: false,
      printSelectedMembershipCardsSelected: false,
      sendMassEmailSelected: false,
      sendMassSMSSelected: false
    })

  private checkCancelMemberships = (): void =>
    this.setState({
      addDaysToEndDateSelected: false,
      cancelSelectedMembershipsSelected: true,
      cancelSelectedMembershipsAndPaymentsSelected: false,
      printSelectedMembershipCardsSelected: false,
      sendMassEmailSelected: false,
      sendMassSMSSelected: false
    })

  private checkCancelMembershipsAndPayments = (): void =>
    this.setState({
      addDaysToEndDateSelected: false,
      cancelSelectedMembershipsSelected: false,
      cancelSelectedMembershipsAndPaymentsSelected: true,
      printSelectedMembershipCardsSelected: false,
      sendMassEmailSelected: false,
      sendMassSMSSelected: false
    })

  private checkPrint = (): void =>
    this.setState({
      addDaysToEndDateSelected: false,
      cancelSelectedMembershipsSelected: false,
      cancelSelectedMembershipsAndPaymentsSelected: false,
      printSelectedMembershipCardsSelected: true,
      sendMassEmailSelected: false,
      sendMassSMSSelected: false,
      exportCsv: false
    })

  private checkMassEmail = (): void =>
    this.setState({
      addDaysToEndDateSelected: false,
      cancelSelectedMembershipsSelected: false,
      cancelSelectedMembershipsAndPaymentsSelected: false,
      printSelectedMembershipCardsSelected: false,
      sendMassEmailSelected: true,
      sendMassSMSSelected: false,
      emailTemplateId: undefined,
      exportCsv: false
    })

  private checkMassSMS = (): void =>
    this.setState({
      addDaysToEndDateSelected: false,
      cancelSelectedMembershipsSelected: false,
      cancelSelectedMembershipsAndPaymentsSelected: false,
      printSelectedMembershipCardsSelected: false,
      sendMassEmailSelected: false,
      sendMassSMSSelected: true,
      exportCsv: false
    })

  private checkExportCsv = (): void =>
    this.setState({
      addDaysToEndDateSelected: false,
      cancelSelectedMembershipsSelected: false,
      cancelSelectedMembershipsAndPaymentsSelected: false,
      printSelectedMembershipCardsSelected: false,
      sendMassEmailSelected: false,
      sendMassSMSSelected: false,
      exportCsv: true
    })

  private sendSMSToMobile2CheckboxChange = (
    event: React.MouseEvent<HTMLInputElement>,
    isInputChecked: boolean): void => {
    this.setState({
      sendMassSMSToMobile2: isInputChecked
    });
  }

  private onClickActionSubmit = (): void => {
    if (this.state.addDaysToEndDateSelected) {
      return this.setState(
        { openActionsModal: false, addDaysToEndDateSelected: false },
        () => this.props.bulkAddDaysToEndDates(this.state.selection, this.state.daysToAdd)
      );
    } else if (this.state.cancelSelectedMembershipsSelected) {
      return this.setState(
        { openActionsModal: false, cancelSelectedMembershipsSelected: false },
        () => this.props.bulkCancel(this.state.selection, true, false)
      );
    } else if (this.state.cancelSelectedMembershipsAndPaymentsSelected) {
      return this.setState(
        { openActionsModal: false, cancelSelectedMembershipsSelected: false },
        () => this.props.bulkCancel(this.state.selection, true, true)
      );
    } else if (this.state.printSelectedMembershipCardsSelected) {
      return this.setState(
        {
          openActionsModal: false,
          loadingActions: true
        }
      );
    } else if (this.state.sendMassEmailSelected) {
      return this.setState(
        { openActionsModal: false, sendMassEmailSelected: false },
        () => this.props.bulkSendEmail(this.state.selection, this.state.emailTemplateId)
      );
    } else if (this.state.sendMassSMSSelected) {
      this.props.bulkSendSms(this.state.selection, this.state.smsContent,
        this.state.sendMassSMSToMobile2);
      return this.setState(
        { openActionsModal: false, sendMassSMSSelected: false, sendMassSMSToMobile2: false }
      );
    } else if (this.state.exportCsv) {
      this.props.exportCsv(this.state.selection);
      return this.setState(
        { openActionsModal: false, exportCsv: false }
      );
    } else {
      return;
    }
  }

  private createTableData = (m: Member): TableDataType => {
    return {
      id: m.id,
      memberId: m.memberId,
      firstName: m.firstName,
      lastName: m.lastName,
      endDate: moment(new Date(m.endDate)).format('MMM DD YYYY'),
      dateOfBirth: m.birthDate ? moment(new Date(m.birthDate)).format('MMM DD YYYY') : '',
      status: getMembershipStatus(m, this.props.packageState),
      programs: m.programNames,
      endDateNumber: m.endDate
    };
  }

  private handleFilterByProgramChange = (event: React.SyntheticEvent<{}>, index: number, value: string): void =>
    this.setState({ filterByProgram: value }, this.applyFilters)

  private isMemberExpiring = (member: Member, newValue: number): boolean => {
    const { packageState } = this.props;

    if (newValue === 0) {
      return true;
    } else if (member.memberType === PACKAGE_BASED) {
      const packages: MmsPackage[] = packageState.packages.filter((p: MmsPackage) => p.memberId === member.id);

      return packages.filter((p: MmsPackage) => {
        const diff = p.expiryDate - new Date().getTime();
        const weekInMillies = newValue * 1000 * 7 * 24 * 60 * 60;
        return weekInMillies > diff;
      }).length > 0;
    } else {
      const diff = member.endDate - new Date().getTime();
      const weekInMillies = newValue * 1000 * 7 * 24 * 60 * 60;
      return weekInMillies > diff;
    }
  }

  private applyFilters = () => {
    const { filters } = this.state;
    const { membersState } = this.props;
    let filtered = [];

    if (filters.length === 0) {
      filtered = membersState.members;
    } else {
      membersState.members.forEach((m: Member) => {
        var match = 0;
        filters.forEach((f: Filter) => {
          switch (f.field) {
            case 'Status':
              match += this.applySingleFilter(f, getMembershipStatus(m, this.props.packageState), m);
              break;
            case 'Name':
              match += this.applySingleFilter(f, m.firstName + ' ' + m.lastName, m);
              break;
            case 'Expiring':
              match += this.applySingleFilter(f, m.endDate, m);
              break;
            case 'Absent':
              match += this.applySingleFilter(f, m.lastCheckInDate, m);
              break;
            case 'Program':
              match += this.applySingleFilter(f, m.programNames, m);
              break;
            case 'Tag':
              match += this.applySingleFilter(f, m.tags, m);
              break;
            case 'Date of Birth':
              match += this.applySingleFilter(f, m.birthDate, m);
              break;
            case 'Point':
              match += this.applySingleFilter(f, m.point, m);
              break;
            case 'Phone':
              var result1 = this.applySingleFilter(f, m.mobile1, m);
              var result2 = this.applySingleFilter(f, m.mobile2, m);
              if (result1 + result2 > 1) {
                match++;
              }
              break;
            default:
              match += 1;
              break;
          }
        });
        if (match === 0) {
          filtered.push(m);
        }
      });
    }
    return filtered;
  }
  private applySingleFilter = (filter: Filter, value: any, member: Member): number => {

    var match = false;
    switch (filter.operation) {
      case 'lt':
        match = Number(filter.value) > Number(value);
        break;
      case 'lte':
        match = Number(filter.value) >= Number(value);
        break;
      case 'eq':
        match = Number(filter.value) === Number(value);
        break;
      case 'gte':
        match = Number(filter.value) <= Number(value);
        break;
      case 'gt':
        match = Number(filter.value) < Number(value);
        break;
      case 'is':
        switch (filter.field) {
          case 'Program':
          case 'Tag':
            if (value) {
              match = value.includes(filter.value);
            } else {
              match = false;
            }
            break;
          default:
            match = String(value).toLocaleLowerCase() === String(filter.value).toLocaleLowerCase();
            break;
        }
        break;
      case 'contains':
        match = String(value).toLocaleLowerCase().includes(String(filter.value).toLocaleLowerCase());
        break;
      case 'in':
        switch (filter.field) {
          case 'Date of Birth':
            var dateOfBirth = new Date(value);
            match = String(filter.value).toLocaleLowerCase() ===
              monthMapping[dateOfBirth.getMonth()].toLocaleLowerCase();
            break;
          case 'Expiring':
            const { packageState } = this.props;
            const weeks = Number(filter.value.charAt(0));
            if (member.endDate - new Date().getTime() <= 0 || member.cancelled) {
              match = false;
              break;
            }
            if (weeks === 0) {
              match = true;
            } else if (member.memberType === PACKAGE_BASED) {
              const packages: MmsPackage[] = packageState.packages.filter((p: MmsPackage) => p.memberId === member.id);

              match = packages.filter((p: MmsPackage) => {
                const diff = p.expiryDate - new Date().getTime();
                const weekInMillies = weeks * 1000 * 7 * 24 * 60 * 60;
                match = weekInMillies > diff;
              }).length > 0;
            } else {
              const diff = member.endDate - new Date().getTime();
              const weekInMillies = weeks * 1000 * 7 * 24 * 60 * 60;
              match = weekInMillies > diff;
            }
            break;
          default:
            break;
        }
        break;
      case 'for':
        switch (filter.field) {
          case 'Absent':
            const weeks = Number(filter.value.charAt(0));
            if (!member.lastCheckInDate) {
              match = true;
              break;
            }
            const diff = new Date().getTime() - member.lastCheckInDate;
            const weekInMillies = weeks * 1000 * 7 * 24 * 60 * 60;
            match = weekInMillies < diff;
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }

    return match ? 0 : 1;
  }

  private handleFilterOptionChange = (event: React.SyntheticEvent<{}>, index: number, value: FilterOption): void => {

    this.loadMembersList();
    this.setState(
      {
        filterOption: value,
        tableData: this.state.members.map((m: Member) => this.createTableData(m)),
        filterById: '',
        filterByName: '',
        expiringInWeekFilter: 0,
        absentInWeekFilter: 0,
        filterByProgram: NOT_AVAILABLE,
        filterByTag: NOT_AVAILABLE,
        filterByBirthDate: undefined,
        filterByPoint: 0,
        filterByPointError: '',
        filterByPhone: ''
      },
      this.applyFilters
    );
  }

  private isSelected = (key) => {
    /*
      Instead of passing our external selection state we provide an 'isSelected'
      callback and detect the selection state ourselves. This allows any implementation
      for selection (either an array, object keys, or even a Javascript Set object).
    */
    return this.state.selection.includes(key);
  }

  private toggleSelection = (key, shift, row) => {
    /*
      Implementation of how to manage the selection state is up to the developer.
      This implementation uses an array stored in the component state.
      Other implementations could use object keys, a Javascript Set, or Redux... etc.
    */
    // start off with the existing state
    let selection = [
      ...this.state.selection
    ];
    const keyIndex = selection.indexOf(key);
    // check to see if the key exists
    if (keyIndex >= 0) {
      // it does exist so we will remove it using destructing
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1)
      ];
    } else {
      // it does not exist so add it
      selection.push(key);
    }
    // update the state
    this.setState({ selection });
  }

  private toggleAll = () => {
    /*
      'toggleAll' is a tricky concept with any filterable table
      do you just select ALL the records that are in your data?
      OR
      do you only select ALL the records that are in the current filtered data?
      
      The latter makes more sense because 'selection' is a visual thing for the user.
      This is especially true if you are going to implement a set of external functions
      that act on the selected information (you would not want to DELETE the wrong thing!).
      
      So, to that end, access to the internals of ReactTable are required to get what is
      currently visible in the table (either on the current page or any other page).
      
      The HOC provides a method call 'getWrappedInstance' to get a ref to the wrapped
      ReactTable and then get the internal state and the 'sortedData'. 
      That can then be iterrated to get all the currently visible records and set
      the selection state.
    */
    const selectAll = !this.state.selectAll;
    const selection = [];
    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.checkboxTable.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach((item) => {
        selection.push(item._original.id);
      });
    }
    this.setState({ selectAll, selection });
  }

  private selectedMemberTypeChangeHandler = (updated: MemberType): void =>
    this.setState({ selectedMemberType: updated })

  private memberChangeHandler = (updatedMember: Member, hasError: boolean): void =>
    this.setState({
      detailDisplayMember: updatedMember,
      hasMemberDetailError: hasError
    })

  private loadMembersList = (): void => {
    this.setState({ loadedMembersList: false });
    this.props.getMembers()
      .then(response => {
        switch (this.props.membersState.statusCode) {
          case 404:
            return;
          case 403:
            return this.props.toDashboard();
          case 200:
            return this.setState(
              {
                members: this.props.membersState.members,
                tableData: this.props.membersState.members.map((m: Member) => this.createTableData(m)),
                loading: false,
                loadedMembersList: true
              },
              this.applyFilters
            );
          default:
            return;
        }
      });
  }

  private memberClickHandler(memberId: number) {
    mmsStore.dispatch({ type: PAYMENTS_TABLE_ROW_UNCLICKED });

    this.props.getMember(memberId)
      .then((membersResponseData) => {
        const { membersState } = this.props;
        switch (membersState.statusCode) {
          case 404:
            return;
          case 200:
            this.setState(
              {
                detailDisplayMember: {
                  ...membersState.member,
                  scheduledPayments: membersState.member.payments.length > 0 &&
                    membersState.member.payments[0].scheduleDetails ?
                    membersState.member.payments[0].scheduleDetails.map(s => {
                      return {
                        scheduledPaymentId: s.scheduledPaymentId,
                        chargeDate: moment(s.chargeDate),
                        amount: `${s.amount}`,
                        editableFieldError: ''
                      };
                    }) :
                    []
                },
                selectedMemberType: membersState.member.memberType,
                unsavedRemainingClasses: membersState.member.remainingClasses,
                currentPaymentInfo: _.cloneDeep(membersState.member.payments[0]),
                currentProgramMembers: _.cloneDeep(membersState.member.programMembers),
                memberDetailsMode: 'EDIT',
                tableData: membersState.members.map((m: Member) => this.createTableData(m))
              },
              this.toggleMembersDetailsModal
            );
            return;
          default:
            return;
        }
      });
  }

  private addMemberToPrintHandler(member: Member) {

    const memberToAdd: Member = _.cloneDeep(member);
    this.setState({
      membersToPrint: [...this.state.membersToPrint, memberToAdd],
      shouldPrintMembersCard: true
    });
  }

  private removeMemberFromPrintHandler(index: number) {
    let newMembersToPrint = this.state.membersToPrint;
    newMembersToPrint.splice(index, 1);
    this.setState({
      membersToPrint: newMembersToPrint
    });
  }

  private clearMembersFromPrint() {
    this.setState({
      membersToPrint: []
    });
  }

  private toggleMembersDetailsModal() {
    if (!this.state.showMemberDetailsModal) {
      this.setState({
        memberImageFile: undefined,
        selectedCancelPayment: false
      });
    }

    if (this.state.memberDetailsMode === 'CREATE') {
      const today: Date = new Date();
      const displayDetail: Member = {
        ..._.cloneDeep(initialMemberDetail),
        birthDate: today.getTime(),
        startDate: today.getTime(),
        endDate: new Date(today.getFullYear() + 1, today.getMonth(), today.getDate()).getTime(),
        payments: [
          {
            ..._.cloneDeep(initialMemberDetail.payments[0]),
            startDate: today.getTime()
          },
          ..._.cloneDeep(initialMemberDetail.payments.slice(1))
        ]
      };

      this.setState({
        detailDisplayMember: displayDetail,
        selectedMemberType: TIME_BASED,
        currentPaymentInfo: _.cloneDeep(initialMemberDetail.payments[0]),
        currentProgramMembers: []
      });
    }

    this.setState(
      {
        showMemberDetailsModal: !this.state.showMemberDetailsModal,
        unsavedPaymentModal: false
      },
      this.applyFilters
    );
  }

  private onMemberImageFileChangeHandler(fileFormatError: string, fileSizeError: string, newImageFile: File) {
    this.setState({
      fileFormatError: fileFormatError,
      fileSizeError: fileSizeError,
      memberImageFile: newImageFile
    });
  }

  private onClickMemberSubmit = (): void => {

    if (this.isMemberInfoComplete() && !this.state.hasMemberDetailError) {
      this.setState(
        { loading: !isAuthTokenExpired() },
        () => {
          if (this.state.detailDisplayMember.id === 0) {
            this.props.createMember(
              this.state.memberImageFile,
              this.state.detailDisplayMember.firstName,
              this.state.detailDisplayMember.lastName,
              this.state.detailDisplayMember.initial,
              this.state.detailDisplayMember.gender,
              this.state.detailDisplayMember.birthDate,
              this.state.detailDisplayMember.email,
              this.state.detailDisplayMember.address,
              this.state.detailDisplayMember.city,
              this.state.detailDisplayMember.province,
              this.state.detailDisplayMember.country,
              this.state.detailDisplayMember.postalCode,
              this.state.detailDisplayMember.mobile1,
              this.state.detailDisplayMember.mobile2,
              this.state.detailDisplayMember.startDate,
              this.state.selectedMemberType === PACKAGE_BASED ?
                YEAR_3000_PACKAGE_BASED_END_DATE :
                this.state.detailDisplayMember.endDate,
              this.state.detailDisplayMember.emergencyContactName1,
              this.state.detailDisplayMember.emergencyContactNumber1,
              this.state.detailDisplayMember.emergencyContactName2,
              this.state.detailDisplayMember.emergencyContactNumber2,
              this.state.detailDisplayMember.emergencyContactName3,
              this.state.detailDisplayMember.emergencyContactNumber3,
              this.state.detailDisplayMember.checkinNotification,
              this.state.detailDisplayMember.contractDuration,
              this.state.detailDisplayMember.maxAttendancePerWeek,
              this.state.detailDisplayMember.point,
              this.state.detailDisplayMember.note,
              this.state.detailDisplayMember.emailConsent,
              this.state.detailDisplayMember.smsConsent,
              this.state.selectedMemberType === TIME_BASED ?
                this.state.unsavedRemainingClasses :
                this.state.detailDisplayMember.remainingClasses,
              this.state.selectedMemberType,
              this.state.detailDisplayMember.tags
            )
              .then((payersResponseData) => {
                this.setState(
                  { loading: false }
                );

                switch (this.props.membersState.statusCode) {
                  case 404:
                    return;
                  case 400:
                    return this.setState({ badProfilePicModalOpen: true });
                  case 200:
                    this.setState(
                      {
                        members: this.props.membersState.members,
                        tableData: this.props.membersState.members.map((m: Member) => this.createTableData(m))
                      },
                      () => {
                        this.toggleMembersDetailsModal();
                        this.handleRedirectToPaymentListPage(true);
                      }
                    );
                    return;
                  default:
                    return;
                }
              });
          } else {
            this.props.updateMember(
              this.state.detailDisplayMember.id,
              this.state.memberImageFile,
              this.state.detailDisplayMember.firstName,
              this.state.detailDisplayMember.lastName,
              this.state.detailDisplayMember.initial,
              this.state.detailDisplayMember.gender,
              this.state.detailDisplayMember.birthDate,
              this.state.detailDisplayMember.email,
              this.state.detailDisplayMember.address,
              this.state.detailDisplayMember.city,
              this.state.detailDisplayMember.province,
              this.state.detailDisplayMember.country,
              this.state.detailDisplayMember.postalCode,
              this.state.detailDisplayMember.mobile1,
              this.state.detailDisplayMember.mobile2,
              this.state.detailDisplayMember.startDate,
              this.state.selectedMemberType === PACKAGE_BASED ?
                YEAR_3000_PACKAGE_BASED_END_DATE :
                this.state.detailDisplayMember.endDate,
              this.state.detailDisplayMember.emergencyContactName1,
              this.state.detailDisplayMember.emergencyContactNumber1,
              this.state.detailDisplayMember.emergencyContactName2,
              this.state.detailDisplayMember.emergencyContactNumber2,
              this.state.detailDisplayMember.emergencyContactName3,
              this.state.detailDisplayMember.emergencyContactNumber3,
              this.state.detailDisplayMember.checkinNotification,
              this.state.detailDisplayMember.contractDuration,
              this.state.detailDisplayMember.maxAttendancePerWeek,
              this.state.detailDisplayMember.point,
              this.state.detailDisplayMember.note,
              this.state.detailDisplayMember.emailConsent,
              this.state.detailDisplayMember.smsConsent,
              this.state.detailDisplayMember.cancelled,
              this.state.selectedMemberType === TIME_BASED ?
                this.state.unsavedRemainingClasses :
                this.state.detailDisplayMember.remainingClasses,
              this.state.selectedMemberType,
              this.state.detailDisplayMember.tags,
              this.state.selectedCancelPayment,
              this.state.selectedSendCancellationNotification,
            )
              .then((payersResponseData) => {
                const redirectToPaymentListPage = this.state.openRedirectPageModal;
                this.setState(
                  { loading: false, confirmationModalOpen: false, openRedirectPageModal: false }
                );

                switch (this.props.membersState.statusCode) {
                  case 404:
                    return;
                  case 400:
                    return this.setState({ badProfilePicModalOpen: true });
                  case 200:
                    this.setState(
                      {
                        members: this.props.membersState.members,
                        tableData: this.props.membersState.members.map((m: Member) => this.createTableData(m)),
                        selectedCancelPayment: false
                      }, () => {
                        this.toggleMembersDetailsModal();
                        if (redirectToPaymentListPage) {
                          this.props.toPaymentList();
                        }
                      }
                    );
                    return;
                  default:
                    return;
                }
              });
          }
        }
      );
    }
  }

  private handleRedirectToPaymentListPage = (isCreate: boolean): void => {
    if (isCreate) {
      mmsStore.dispatch({
        type: RIDIRECT_FROM_MEMBER,
        payload: {
          body: {
            entity: { memberId: this.props.membersState.newMember.id }
          }
        }
      });
    }

    this.setState({
      openRedirectPageModal: true,
      isCreateRedirectAction: isCreate
    });
  }

  private isMemberInfoComplete = (): boolean => {
    const { detailDisplayMember } = this.state;

    return detailDisplayMember.firstName !== ''
      && detailDisplayMember.lastName !== ''
      && detailDisplayMember.mobile1 !== ''
      && detailDisplayMember.email !== ''
      && detailDisplayMember.startDate < detailDisplayMember.endDate
      && detailDisplayMember.maxAttendancePerWeek >= 0
      && detailDisplayMember.point >= 0;
  }

  private isProgramDetailUpdated(toCheck: ProgramMemberInfo, original: ProgramMemberInfo) {
    if (!toCheck || !original) {
      return false;
    }

    if (!original.level && toCheck.level) {
      return true;
    }

    if (!toCheck.level || toCheck.level.id !== original.level.id) {
      return true;
    }

    let originalScheduleIds = original.schedules.map((schedule: Schedule) => schedule.id);
    for (let i = 0; i < toCheck.schedules.length; i++) {
      if (originalScheduleIds.indexOf(toCheck.schedules[i].id) === -1) {
        return true;
      }
    }

    return toCheck.schedules.length !== original.schedules.length;
  }

  private printMembersCards = (): void => {
    this.setState(
      {
        shouldPrintMembersCard: true,
        shouldPrintEnrollmentForm: false,
        loadingActions: false,
        printSelectedMembershipCardsSelected: false
      },
      () => window.print()
    );
  }

  private printMemberEnrollmentForm = (): void =>
    this.setState(
      {
        shouldPrintMembersCard: false,
        shouldPrintEnrollmentForm: true
      },
      () => window.print()
    )

  private closeConfirmationModal = (): void => this.setState({ confirmationModalOpen: false });

  private closeBadProfilePicModal = (): void => this.setState({ badProfilePicModalOpen: false });

  private closeActionsModal = (): void => this.setState({
    openActionsModal: false,
    addDaysToEndDateSelected: false,
    cancelSelectedMembershipsSelected: false,
    printSelectedMembershipCardsSelected: false,
    sendMassEmailSelected: false,
    sendMassSMSSelected: false,
    emailTemplateId: undefined
  })

  private renderBadProfilePicModal = (): JSX.Element => {
    return (
      <Dialog
        title="Bad Profile Picture Warning"
        actions={[
          this.renderCancelButton(this.closeBadProfilePicModal),
        ]}
        modal={true}
        open={this.state.badProfilePicModalOpen}
        onRequestClose={() => this.setState({ badProfilePicModalOpen: false })}
      >
        A profile picture of a member must have member's face in it.
      </Dialog>
    );
  }

  private renderConfirmationModal = (): JSX.Element => {
    return (
      <Dialog
        title="Confirm Update"
        actions={[
          this.renderCancelButton(this.closeConfirmationModal),
          this.renderSubmitButton(() => {
            this.setState(
              { confirmationModalOpen: false },
              this.onClickMemberSubmit
            );
          })
        ]}
        modal={true}
        open={this.state.confirmationModalOpen}
        onRequestClose={() => this.setState({ confirmationModalOpen: false })}
      >
        Update is made in Payer, Payment Method, and/or Payment section(s). Current scheduled payments will be replaced.
      </Dialog>
    );
  }

  private renderUnsavedPaymentModal = (): JSX.Element => {
    return (
      <Dialog
        title="Unsaved Payment"
        actions={[
          this.renderNoButton(),
          this.renderYesButton(),
        ]}
        modal={true}
        open={this.state.unsavedPaymentModal}
        onRequestClose={() => this.setState({ unsavedPaymentModal: false })}
      >
        You have created a new payment. Are you sure you want to close without creating a member.
      </Dialog>
    );
  }

  private renderYesButton = () => {
    return (
      <FlatButton
        label="Yes"
        primary={true}
        onClick={this.toggleMembersDetailsModal}
      />
    );
  }

  private renderNoButton = () => {
    return (
      <FlatButton
        label="No"
        primary={true}
        onClick={() => this.setState({ unsavedPaymentModal: false })}
      />
    );
  }

  private renderCancelButton = (onClickFunction: (e: React.SyntheticEvent<{}>) => void): JSX.Element => {
    return (
      <FlatButton
        label="Cancel"
        secondary={true}
        onClick={onClickFunction}
      />
    );
  }

  private renderSubmitButton = (
    onClickFunction: (e: React.SyntheticEvent<{}>) => void,
    isDisabled?: boolean
  ): JSX.Element => {
    return (
      <FlatButton
        label="Submit"
        primary={true}
        disabled={isDisabled ? isDisabled : false}
        onClick={onClickFunction}
      />
    );
  }
}

export default MembersComponent;



// WEBPACK FOOTER //
// ./src/members/MembersComponent.tsx